/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_ConciergeInputs */

const en_ai_concierge = /** @type {(inputs: Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Concierge`)
};

const es_ai_concierge = /** @type {(inputs: Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conserje IA`)
};

const fr_ai_concierge = /** @type {(inputs: Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concierge IA`)
};

const de_ai_concierge = /** @type {(inputs: Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Concierge`)
};

const ja_ai_concierge = /** @type {(inputs: Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIコンシェルジュ`)
};

const zh_ai_concierge = /** @type {(inputs: Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 礼宾客服`)
};

const ar_ai_concierge = /** @type {(inputs: Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المساعد الذكي (الكونسيرج)`)
};

const id_ai_concierge = /** @type {(inputs: Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pramutamu AI`)
};

const it_ai_concierge = /** @type {(inputs: Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concierge IA`)
};

const ru_ai_concierge = /** @type {(inputs: Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИИ-Консьерж`)
};

const pt_ai_concierge = /** @type {(inputs: Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concierge IA`)
};

const ko_ai_concierge = /** @type {(inputs: Ai_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 컨시어지`)
};

/**
* | output |
* | --- |
* | "AI Concierge" |
*
* @param {Ai_ConciergeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ai_concierge = /** @type {((inputs?: Ai_ConciergeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_ConciergeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ai_concierge(inputs)
	if (locale === "es") return es_ai_concierge(inputs)
	if (locale === "fr") return fr_ai_concierge(inputs)
	if (locale === "de") return de_ai_concierge(inputs)
	if (locale === "ja") return ja_ai_concierge(inputs)
	if (locale === "zh") return zh_ai_concierge(inputs)
	if (locale === "ar") return ar_ai_concierge(inputs)
	if (locale === "id") return id_ai_concierge(inputs)
	if (locale === "it") return it_ai_concierge(inputs)
	if (locale === "ru") return ru_ai_concierge(inputs)
	if (locale === "pt") return pt_ai_concierge(inputs)
	return ko_ai_concierge(inputs)
});